import { Box } from "@mui/material";
import ExternalLinkAnchor from "../../../../common/ExternalLinkAnchor";
import SendInviteEmailButton from "./SendInviteEmailButton";
import LinkToHubspotButton from "./LinkToHubspotButton";

import LinkClientToStripeButton from "./LinkClientToStripeButton";
import { useClientDetails } from "../../../context/clientDetailsContext";

const Actions = () => {
  const {
    client: { details },
  } = useClientDetails();

  if (!details || !details.mainUser) {
    throw Error("Client details are required");
  }

  return (
    <>
      <Box id="hubspot-link-container" sx={{ paddingBottom: 1 }}>
        {details.mainUser.hubspotUrl ? (
          <Box sx={{ display: "flex", justifyContent: "space-between" }}>
            <ExternalLinkAnchor
              url={details.mainUser.hubspotUrl}
              label="Hubspot"
              dataTestid="open-hubspot-anchor"
            />
            <SendInviteEmailButton />
          </Box>
        ) : (
          <LinkToHubspotButton />
        )}
      </Box>
      <Box id="stripe-link-container">
        {details.mainUser.stripeUrl ? (
          <Box sx={{ display: "flex", alignItems: "start" }}>
            <ExternalLinkAnchor
              url={details.mainUser.stripeUrl}
              label="Stripe"
              dataTestid={"open-stripe-anchor"}
            />
          </Box>
        ) : (
          <LinkClientToStripeButton />
        )}
      </Box>
    </>
  );
};

export default Actions;
